<template>
  <Modal
    v-model="visible"
    :title="name + '变更记录'"
    width="800"
    :mask-closable="false"
    :footer-hide="true"
    class="my-modal top p-b"
  >
    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="table-box setTable">
      <Table :columns="columns" :data="list" ref="rowTable">
        <template slot-scope="{ row }" slot="versionCode">
          <a class="table-btn" @click="toPage(row)">{{ row.versionCode }}</a>
        </template>
      </Table>
    </div>

    <div class="pageBox">
      <Page
        :total="total"
        :current="pageNo"
        :page-size="pageSize"
        show-total
        @on-change="pageChange"
        style="text-align: center"
      />
    </div>

  </Modal>
</template>

<script>
import filter from "@/api/filter";
export default {
  props: ['name','id'],
  data() {
    return {
      filter,
      visible: false,
      list: [],
      total:0,
      pageNo: 1,
      pageSize: 10,
      columns: [
        {
          title: "序号",
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "变更时间",
          minWidth: 160,
          align: "center",
          key: "createTime",
        },
        {
          title: "变更人",
          minWidth: 100,
          align: "center",
          key: "createName",
        },
        {
          title: "版本",
          minWidth: 100,
          align: "center",
          slot: "versionCode",
        }
      ],
    };
  },
  methods: {
    async open() {
      this.visible = true;
      this.initList();
    },

    initList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/covenantHistoryVersion/read/list",
        type: "POST",
        data: {
          covenantId: this.id,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        },
      }).then((res) => {
        this.list = res.data;
        this.total = res.total;
        this.$root.$children[0].isShowLoading = false;
      });
    },

    toPage(row) {
      this.$router.push({
        path:"/offline/agreementManage/supplierAgreement/agreementSnapshot",
        query:{
          id:row.id,
          covenantId: this.id,
          type:"3"
        }
      })
    },

    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.initList();
    },
  },
};
</script>

<style lang="scss" scoped>
.my-modal {
  .form {
    display: flex;
    align-items: center;
    margin: 15px 0 20px 0;
    .input-item {
      display: flex;
      align-items: center;
      padding-right: 50px;
    }
    .label {
      min-width: 100px;
    }
    .value {
      width: 300px;
      min-width: 200px;
    }
    /deep/ .add-btn {
      background: #f59045 !important;
      border: none;
    }
  }

  /deep/ {
    .ivu-modal-body {
      padding-top: 0;
      position: relative;
    }
  }

  /deep/ .ivu-modal-footer {
    position: absolute !important;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .table-box {
    margin-top: 20px;
  }
}
</style>